module.exports = __webpack_public_path__ + "img/flag.5f506fe4.svg";